namespace Ir.Components.Filters.DateFilter {
    interface IDateFilterViewModel {
        filter: Filter;
        dateRanges: Array<DateRange>;
        dateFormat: string;
        isWidgetFilter: boolean;
        minWidth: string;

        onPreviousDateClick: Function;
        onNextDateClick: Function;
        dateSettings: DevExpress.ui.dxDateBox.Properties;
        dateComponent: DevExpress.ui.dxDateBox;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;
        
        getFormattedDate: Function;
    }
    
    export function getViewModel(this: IDateFilterViewModel, params: IFilterParameterVM, componentInfo) {
        let self = this;
        this.filter = params.filter;
        this.dateRanges = DateRangeService.OnlySingleDates;
        this.isWidgetFilter = params.isWidgetFilter;
        $(componentInfo.element).addClass("date-filter-comp");
        
        this.filter.previousDateClick = function () {
            self.filter.nextPreviousDateChange(false, self.dateRanges, componentInfo.element, self.isWidgetFilter);
        };
        this.filter.nextDateClick = function () {
            self.filter.nextPreviousDateChange(true, self.dateRanges, componentInfo.element, self.isWidgetFilter);
        };

        this.dateFormat = irSettings.shortDateFormat;
        
        this.getFormattedDate = function (value) {
            if (value) {
                let date = DevExpress.localization.parseDate(value, "yyyy-MM-dd");
                let displayDate = DevExpress.localization.formatDate(date, self.dateFormat);
                return displayDate;
            }

            return value === null ? irSettings.nullText : "";
        };

        this.filter.startDisplayCondition(this.getFormattedDate(this.filter.startCondition()));

        let updatingDateRangeType = false;
        this.minWidth = this.isWidgetFilter ? "65px" : "unset";
        this.dateSettings = {
            disabled: ko.computed(function () {
                return self.filter.readOnly();
            }) as any,
            width: 65,
            type: "date",
            displayFormat: this.dateFormat,
            value: this.filter.startCondition as any,

            openOnFieldClick: true,
            showDropDownButton: false,
            inputAttr: { onfocus: "this.select()" },
            onFocusIn: function (e) {
                e.element.select();
            },
            onInitialized(e) {
                self.filter.getComponent = function () { return e.component; };
                self.dateComponent = e.component;
            },
            onValueChanged: function (e) {
                if (e.previousValue !== e.value) {
                    if (!updatingDateRangeType) {
                        self.filter.dateRange(irGlobal.customDate.custom);
                        self.filter.dateRangeConfig.userDates(true);
                        self.filter.dateRangeConfig.lastDateUsed(null);
                        self.filter.dateRangeConfig.startDate(null);
                        self.filter.dateRangeConfig.endDate(null);
                    }
                    else {
                        self.filter.dateRangeConfig.userDates(false)
                    }

                    self.filter.dateRangeConfig.multiplier(0);

                    updatingDateRangeType = false;
                    self.filter.startCondition(e.value);
                    self.filter.startDisplayCondition(self.getFormattedDate(self.filter.startCondition()));
                    self.filter.publish();
                }
            },
            onContentReady: function (e) {
                if (self.filter.onContentReady) {
                    self.filter.onContentReady();
                }
            }
        }

        this.filter.dateRange.subscribe(function (newValue) {
            if (irGlobal.customDate.custom !== newValue) {
                let dateRange = self.dateRanges.find(function (x) { return x.id() === newValue; });
                if (dateRange) {
                    updatingDateRangeType = true;
                    self.filter.startCondition(dateRange.startDate());
                }
            }
        });

        this.nullButtonParams = {
            filter: this.filter,
            visible: this.filter.showNullButton(),
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    self.filter.dateRange(irGlobal.customDate.today);
                }
                else {
                    self.filter.startCondition(null);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.dateComponent.element().focus();
            }
        };
    }
}